<script>
    import Accordion from "../../components/Button/Accordion.svelte";
    import { settings } from "../../stores/settingsStore";

    const urlParams = new URLSearchParams(window.location.search);
    const sectionId = urlParams.get('sectionId');
</script>

<style>
    ol,
    ul {
        list-style: circle;
        margin: 0;
        padding-left: 20px;
    }
</style>

<div class="container mx-auto w-full flex flex-col gap-2 md:bg-none">
    <div class="flex flex-col content-center items-center select-none w-full">
        <div class="title-red font-bold w-full text-left">
            Serve aiuto?
        </div>

        <div class="text-3xl font-450 w-full text-left">
            Qui trovi alcune risposte che potrebbero a aiutarti per completare l’adesione
        </div>
    </div>

    <div>
        <Accordion id="requirements" openId={sectionId} title="Cosa mi serve per fare l'adesione?">
            L'adesione richiede:
            <ul class="font-bold">
                <li>
                    L’inserimento di tutti i propri dati come da form visualizzato compreso il tuo CODICE FISCALE (*)
                </li>

                <li>
                    Il pagamento di una quota minima di {$settings.minimumPaymentNotUGS}€ ({$settings.minimumPaymentUGS}€ per i/le giovani under {$settings.ugsMaxAgeInclusive} anni che scelgono di aderire ad UGS)
                </li>
                <li>
                    Nel caso di raccolta di adesioni di altre persone ti servono:
                    <ul>
                        <li>Dati personali delle/degli aderenti (per i/le nuovi/e raccolti sul MODULO apposito e firmati per la liberatoria della privacy)</li>
                        <li>Il pagamento di una quota minima di {$settings.minimumPaymentNotUGS}€ ({$settings.minimumPaymentUGS}€ se si aderisce ad UGS - giovani sotto i {$settings.ugsMaxAgeInclusive} anni)</li>
                    </ul>
                </li>
            </ul>
            <br>

            <span class="font-bold">(*) IMPORTANTE NOVITÀ</span> per il 2026: Tra i dati richiesti nel form di iscrizione c’è anche il tuo <span class="font-bold">CODICE FISCALE</span>.
            Verifica quindi di averlo con te al momento dell’iscrizione nuova o rinnovo iscrizione di anni precedenti.
            Il CF sarà l’identificativo univoco della tua identità con cui richiamare i tuoi dati di iscrizione.
            <br>
            Se hai inserito i tuoi dati senza errori, potrai anche generare il tuo <span class="font-bold">CODICE FISCALE</span>
            cliccando l’apposito pulsante <span class="font-bold">GENERA</span> che trovi a fianco del campo CF.
        </Accordion>

        <Accordion id="payment" openId={sectionId} title="Ho iniziato l’adesione ma non sono riuscito a concludere il pagamento">
            Ad iscrizione effettuata verrai indirizzata/o nella pagina di pagamento gestita attraverso la piattaforma PayWay di Numia. Se per ragioni diverse (calo della rete, interruzione del collegamento, altro), non fossi riuscita/o a concludere l’operazione del pagamento tessera, potrai procedere all'invio della quota di iscrizione <span class="underline">esclusivamente</span> con uno di questi tipi di invio di denaro:
            <br>
            <br>
            <span class="font-bold">Con Paypal</span>
            <ul>
                <li>Vai su <a href="www.paypal.it">www.paypal.it</a></li>
                <li>Accedi in paypal con il tuo accesso PayPal</li>
                <li>Clicca su Invia denaro</li>
                <li>Inserisci la mail <a class="text-lightBlue-500" href="mailto:adesioni.si@gmail.com">adesioni.si@gmail.com</a></li>
                <li>Clicca su <span class="font-bold">AVANTI</span></li>
                <li>Inserisci l'importo</li>
                <li>Specifica nella causale: <span class="font-bold">Pagamento tessera 2026 Nome e Cognome (se fai un pagamento collettivo limitati a Scrivere nr. ..  Tessere Federazione ……. come da elenco inviato a <a href="mailto:adesioni.si@gmail.com">adesioni.si@gmail.com</a>)</span></li>
                <li>Procedi con <span class="font-bold">INVIA</span></li>
            </ul>

            <br>
            <span class="font-bold">Con bonifico bancario</span>
            <ul>
                <li>Indica nella causale di pagamento: Nome e cognome - Tesseramento 2026 (per bonifici collettivi nella causale scrivi: v. elenco tesserati Fed. ….. inviato a <a href="mailto:adesioni.si@gmail.com">adesioni.si@gmail.com</a>)</li>
                <li>BENEFICIARIO: <span class="font-bold">Sinistra Italiana - BANCO BPM - Fil. di Piazza di Montecitorio, Roma</span></li>
                <li>IBAN: <span class="font-bold">IT70F0503403264000000002286</span></li>
                <li>SWIFT: BAPPIT21P23 (solo per l’Estero)</li>
            </ul>
        </Accordion>

        <Accordion id="membership-active" openId={sectionId} title="Ho inserito la richiesta di iscrizione on-line. Il mio tesseramento è già effettivo?" >
            L'inserimento dei dati per il tesseramento deve essere seguito dal versamento della quota che ne è elemento essenziale. Solo al ricevimento del versamento effettuato la tessera verrà registrata come valida.
            <br>
            I responsabili della Federazione provinciale, in ogni caso, vedranno tutti i dati inseriti in tempo reale e se la tessera è stata pagata o non ancora.
        </Accordion>

        <Accordion id="receipt" openId={sectionId} title="Ho pagato la quota tessera con un bonifico o con PayPal, devo inviare la ricevuta del versamento?" >
            No, non è necessario.
            <br>
            Al ricevimento delle quote sul c/c di SI, l'amministrazione invierà la notifica, per l'attivazione della tessera, all’Ufficio del Tesseramento.
            <br>
            Per pagamenti PAYPAL riceveremo direttamente la notifica automatica dell'avvenuto pagamento.
        </Accordion>

        <Accordion id="single-transfer" openId={sectionId} title="Ho fatto l'iscrizione per me e per altre/i, posso fare un unico bonifico?" >
            Sì certo. Il bonifico collettivo deve essere però tassativamente seguito dall'invio dell'elenco delle/dei tesserate/i cui si riferisce, all’indirizzo <a href="mailto:adesioni.si@gmail.com">adesioni.si@gmail.com</a>, in cui si comunicano: nomi, cognomi e quote individuali di iscrizione cui il versamento collettivo si riferisce.
            <br>
            Questo è un invio importante perché le banche troncano a pochi caratteri le causali inserite che, quindi, arriveranno incomplete rendendo impossibile al Partito la validazione di  tutte le singole tessere pagate collettivamente.
        </Accordion>

        <Accordion id="card-delivery" openId={sectionId} title="Quando e come mi arriva la tessera?" >
            Le tessere, una volta validate, verranno stampate su cartoncino al termine di ogni trimestre in cui è stato effettuato il pagamento (il 1° aprile quelle pagate nel 1° trimestre, il 1° luglio quelle nel 2° trimestre, il 1° ottobre quelle nel 3° trimestre e il 2 gennaio dell’anno successivo quelle pagate nel 4° trimestre). Le tessere verranno  spedite ad ogni iscritto/a  all’indirizzo indicato nel form di iscrizione online di ogni iscritto/a attraverso Poste Italiane.
        </Accordion>

        <Accordion id="correct-data" openId={sectionId} title="Ho inserito i miei dati nel tesseramento e mi sono accorto tardi che ho fatto degli errori nella compilazione. Come posso correggere?" >
            Sarà sufficiente inviare (dalla mail con cui ci si è iscritti/e)  i dati da correggere all’indirizzo email <a class="text-lightBlue-500" href="mailto:adesioni.si@gmail.com">adesioni.si@gmail.com</a>.
            <br>
            I/le compagni/e che se ne occupano procederanno a registrare le modifiche.
            <br>
            <span class="font-bold">Il CF sarà l’identificativo univoco della tua identità.</span>
        </Accordion>

        <Accordion id="no-email" openId={sectionId} title="Non ho una casella di posta elettronica. Come posso fare?">
            L’indirizzo di posta elettronica è un dato obbligatorio, necessario affinché Sinistra Italiana possa mantenere un contatto diretto con le proprie iscritte e i propri iscritti. Indirizzi email non validi o mancanti non possono essere accettati e il tesseramento resterà sospeso fino alla comunicazione di un indirizzo corretto.
            <br>
            Per le/ gli iscritte/i che non dispongono di una casella email, sarà compito del responsabile del tesseramento della propria Federazione creare un indirizzo email dedicato da conservare in archivio.
        </Accordion>

        <Accordion id="contact-federation" openId={sectionId} title="Mi sono iscritta/o nella Federazione di .............. (provincia di residenza/domicilio indicato nel form - non necessariamente la residenza anagrafica) come contatto il responsabile del mio territorio?">
            Scrivendo a <a class="text-lightBlue-500" href="mailto:adesioni.si@gmail.com">adesioni.si@gmail.com</a>, chiedendo il contatto della propria Federazione.
        </Accordion>

        <Accordion id="summary-letter" openId={sectionId} title="Ho ricevuto la lettera automatica che riepiloga i miei dati di iscrizione. Devo conservarla?">
            Le lettere di riepilogo dei dati degli/delle iscritti/e sono mail automatiche generate direttamente dal database del tesseramento che consente di verificare con calma i dati inseriti e la loro correttezza oltre a certificare l’avvenuta iscrizione. Si consiglia di conservarla fino al ricevimento della tessera cartacea.
        </Accordion>
    </div>
</div>